const useCaseList = () => import('@/views/pages/useCase/useCaseList/index.vue');
const useCaseForm = () => import('@/views/pages/useCase/useCaseForm/index.vue');
const useCaseSquare = () => import('@/views/pages/useCase/useCaseSquare/index.vue');
const useCaseAdminPanel = () => import('@/views/pages/useCase/useCaseSquare/index.vue');
const useCaseDashboard = () => import('@/views/pages/useCase/useCaseDashboard/index.vue');
const dataUseCase = () => import('@/views/pages/useCase/dataUseCase/index.vue');
const AiUseCaseAssistant = () => import('@/views/pages/useCase/aiUseCaseAssistant/index.vue');
const aiGovernanceDetail = () => import('@/views/pages/myworkspace/aiGovernance/detail/index.vue');
const sfUseCase = () => import('@/views/pages/useCase/sfUseCase/index.vue');
const GaiaUseCase = () => import('@/views/pages/useCase/gaiaUseCase/index.vue');

const DtsRouteList = [
  {
    path: 'myUseCase-dts',
    component: useCaseList,
    name: '/myUseCase-dts',
    meta: {
      ownType: 'DTS',
      lableTitle: 'Use Case Square',
      mid: 'b7c2-6a49',
    },
  },
  {
    path: 'useCaseForm-dts',
    component: useCaseForm,
    name: '/useCaseForm-dts',
    meta: {
      ownType: 'DTS',
      lableTitle: 'Use Case Form',
      mid: '9d5a-0f8e',
    },
  },
  {
    path: 'dataUseCase-dts',
    component: dataUseCase,
    name: '/dataUseCase-dts',
    meta: {
      ownType: 'DTS',
      lableTitle: 'Use Case Form',
      mid: '3c6b-e9a1',
    },
  },
  {
    path: 'useCaseSquare-dts',
    component: useCaseSquare,
    name: '/useCaseSquare-dts',
    meta: {
      ownType: 'DTS',
      lableTitle: 'Use Case Square',
      mid: '0e8d-5f2b',
    },
  },
  {
    path: 'useCaseAdminPanel-dts',
    component: useCaseAdminPanel,
    name: '/useCaseAdminPanel-dts',
    meta: {
      ownType: 'DTS',
      lableTitle: 'Admin Panel',
      mid: 'a4f7-9c16',
    },
  },
  {
    path: 'useCaseDashboard-dts',
    component: useCaseDashboard,
    name: '/useCaseDashboard-dts',
    meta: {
      ownType: 'DTS',
      lableTitle: 'Admin Panel',
      mid: 'd2b5-8e03',
    },
  },
  {
    path: 'aiUseCaseAssistant-dts',
    component: AiUseCaseAssistant,
    name: '/aiUseCaseAssistant-dts',
    meta: {
      ownType: 'DTS',
      lableTitle: '',
      mid: '6a9c-1f47',
    },
  },
  {
    path: 'gaiaUseCase-dts',
    component: GaiaUseCase,
    name: '/gaiaUseCase-dts',
    meta: {
      ownType: 'DTS',
      lableTitle: '',
      mid: 'f1e8-4b25',
    },
  },
  {
    path: 'aiGovernanceDetail-dts',
    component: aiGovernanceDetail,
    name: '/aiGovernanceDetail-dts',
    meta: {
      ownType: 'DTS',
      lableTitle: '',
      mid: '7d0a-9c63',
    },
  },
  {
    path: 'sfUseCase-dts',
    component: sfUseCase,
    name: '/sfUseCase-dts',
    meta: {
      ownType: 'DTS',
      lableTitle: '',
      mid: '2e5b-8f14',
    },
  },
];

export default DtsRouteList;
